<template>
  <div>
    <div class="upload_holder mb-4">
        <input type="file"
        accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
            @change="uploadImg($event, 1)">
        
        <div v-if="image==null" style="background: #EBFEFF; border: 1px dashed #00CFDD; border-radius: 6px;" class="text-center p-6">
            <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 20H68V48H76V20C76 15.588 72.412 12 68 12H16C11.588 12 8 15.588 8 20V68C8 72.412 11.588 76 16 76H48V68H16V20Z" fill="#C4E2E3"/>
                <path d="M32 44L20 60H64L48 36L36 52L32 44Z" fill="#C4E2E3"/>
                <path d="M76 56H68V68H56V76H68V88H76V76H88V68H76V56Z" fill="#C4E2E3"/>
            </svg>
            <p style="color: #5C7C7D;">Upload file</p>
        </div>
        <div v-else>
          <div v-if="image.includes('.pdf')">
            <pdf :src="image"></pdf>
          </div>
        <img v-else :src="image" style="width:100%; height:300px; object-fit: contain" />
        <vs-button type="border" color="danger" class="block ml-auto mt-4" @click="clearImage()">Delete</vs-button> 
      </div>
    </div>
  </div>
</template>
<script>
import pdf from 'vue-pdf'

import { UploadImage } from '@/api/common'
import { addFile } from '@/api/file'
import { repository } from '@/mixins/repository.js'

export default {
  components: {
    pdf
  },
  props:{
    platform_module_id:{
      default:''
    },
    image:{
      default:null
    }
  },
  mixins:[repository],
  data () {
    return {
      preview_file:null,
      file:null
    }
  },
  created () {
    this.getRepositoryId(this.platform_module_id)
  },
  methods: {   
    async clearImage () {
      this.image = null
    },
    async uploadImg (event) {
      const input = event.target
      if (input.files) {
        const reader = new FileReader()
        reader.onload = e => {
          this.preview_file = e.target.result
        }
        this.file = input.files[0]
        reader.readAsDataURL(input.files[0])

        const formData = new FormData()
        formData.append('files[]', input.files[0])

        const data = await UploadImage(formData,  localStorage.getItem('customer_id'))
        const cdn = data.data.data.cdn

        const file_name = data.data.data.files[0].file_name
        const file_path = data.data.data.files[0].file_path

        const raw = JSON.stringify({
          file_repository_id: this.repository_id,
          files: [
            {
              file_name,
              file_path: `${cdn}${file_path}`
            }
          ]
        })

        const file_id_payload = raw

        this.getUploadFiles(file_id_payload)
      }
    },
    async getUploadFiles (file_id_payload) {
      const res = await addFile(file_id_payload)

      this.file_id = res.data.data.files[0].files_id
      this.image = res.data.data.files[0].file_path
      this.$emit('changingImage', res.data.data.files[0].file_path)
      this.$vs.loading.close()
    }
  }
}
</script>